
import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  category: string;
  categoryColor: string;
  excerpt: string;
  image: string;
  date: string;
  readTime: string;
}

const ArticleCard = ({
  slug,
  title,
  category,
  categoryColor,
  excerpt,
  image,
  date,
  readTime,
}: ArticleCardProps) => {
  return (
    <Link to={`/article/${slug}`} className="group cursor-pointer">
      <article className="bg-white rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 overflow-hidden h-full flex flex-col">
        <div className="relative overflow-hidden">
          <div className="w-full h-56">
            <img
              src={image}
              alt={title}
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
            />
          </div>
          <div className="absolute top-4 left-4">
            <span className={`text-xs font-semibold px-3 py-1 rounded-full ${categoryColor} whitespace-nowrap`}>
              {category}
            </span>
          </div>
        </div>

        <div className="p-6 flex-1 flex flex-col">
          <h3 className="text-xl font-bold text-[#1a1a1a] mb-3 line-clamp-2 group-hover:text-gray-700 transition-colors">
            {title}
          </h3>
          <p className="text-sm text-gray-600 mb-4 line-clamp-3 flex-1">
            {excerpt}
          </p>
          <div className="flex items-center justify-between text-xs text-gray-400 pt-4 border-t border-gray-100">
            <div className="flex items-center gap-1">
              <i className="ri-time-line"></i>
              <span>{date}</span>
            </div>
            <span>{readTime}</span>
          </div>
        </div>
      </article>
    </Link>
  );
};

export default ArticleCard;
